import { post, get } from "./apiClient";
import { uriWithQueryStringParams } from "../utils/urlUtils";

export default {
  async post({ slideViewModel }) {
    return await post("slide", slideViewModel);
  },

  async postImage(facilityId, file, slideName) {
    const data = new FormData();
    data.append(slideName, file);

    return await post(
      uriWithQueryStringParams("slide/image", { facilityId }),
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );
  },

  async get(facilityId) {
    return await get(uriWithQueryStringParams("slide", { facilityId }));
  }
};
